/**
 * Component is used to show order summary applied giftCards on the order confirmation page
 *
 * @param {Array}  [appliedGiftCards] - Applied giftCards for current order
 * @param {String} [price-separator] - price separator sign, e.x. 9,10 or 9.10
 * @param {String} [label] - text label to display applied amount on order summary
 *
 * HTML Structure Example
 * <e2-order-summary-gift-cards
 *    price-separator=","
 *    label="Gift Card">
 * </e2-order-summary-gift-cards>
 *
 */

import connect from '@elab/core/store/connect';
import { selectors } from '@elab/core/store/order';

import { CartSummaryGiftCards } from '../cart/CartSummaryGiftCards';

const mapStateToProps = state => ({
    appliedGiftCards: selectors.getGiftCardTransactions(state),
});

export default () =>
    customElements.define(
        'e2-order-summary-gift-cards',
        connect(mapStateToProps)(CartSummaryGiftCards),
    );
